import { ChannelKind } from "store/types";

/**
 * Channel kinds that can receive sales even when the period is closed.
 * Add a kind here to allow it.
 */
const CLOSED_PERIOD_ALLOWED_KINDS = new Set([ChannelKind.COLLECTIVE_MANAGEMENT]);

export const canAddSalesForKind = (channelKind: ChannelKind, periodClosed: boolean): boolean =>
    !periodClosed || CLOSED_PERIOD_ALLOWED_KINDS.has(channelKind);

export const isNotClosed = (isActive: number | boolean | string | null | undefined): boolean => Number(isActive) > 0;

export const isSaleBlockedByClosedPeriod = (
    matchingPeriods: { isActive: number | boolean | string | null | undefined }[],
    channelKind: ChannelKind,
): boolean => {
    if (canAddSalesForKind(channelKind, true)) return false;
    return !matchingPeriods.some((period) => isNotClosed(period.isActive));
};
